import React from "react";
import { Routes, Route } from "react-router-dom";
import FontLayout from "../Font/components/FontLayout";
import Home from "../Font/pages/Home";
import About from "../Font/pages/About";
import Contact from "../Font/pages/Contact";
import Login from "../Font/pages/Login";
import Notices from "../Font/pages/Notices";
import ResetPassword from "../Font/pages/ResetPassword";



const FontRoutes = () => {
  return (
    <Routes>
       {/* <Route path="reset_pass/:token" element={< ResetPassword />} /> */}
      <Route element={<FontLayout />}>

        {/* Home */}
        <Route index element={< Home />} />

        {/* ✅ FIXED ROUTES */}
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="login" element={< Login />} />
       
        <Route path="notices" element={< Notices />} />

      </Route>
    </Routes>
  );
};

export default FontRoutes;